// MotoBiz Internationalization - English & Bengali

export const translations = {
  en: {
    // Common
    app_name: "MotoBiz",
    tagline: "Vehicle Service Management Platform",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    search: "Search",
    filter: "Filter",
    all: "All",
    actions: "Actions",
    status: "Status",
    date: "Date",
    phone: "Phone",
    email: "Email",
    address: "Address",
    notes: "Notes",
    price: "Price",
    total: "Total",
    subtotal: "Subtotal",
    discount: "Discount",
    currency: "৳",
    
    // Navigation
    nav_home: "Home",
    nav_services: "Services",
    nav_parts: "Parts & Store",
    nav_dashboard: "Dashboard",
    nav_jobs: "Jobs",
    nav_customers: "Customers",
    nav_employees: "Employees",
    nav_inventory: "Inventory",
    nav_invoices: "Invoices",
    nav_reports: "Reports",
    nav_services: "Services",
    nav_settings: "Settings",
    nav_reviews: "Reviews",
    nav_website: "Website",
    nav_more: "More",
    nav_logout: "Logout",
    nav_login: "Login",
    
    // Auth
    login_title: "Welcome Back",
    login_subtitle: "Sign in to manage your service center",
    register_title: "Create Account",
    register_subtitle: "Start managing your vehicle service center",
    email_placeholder: "Enter your email",
    password_placeholder: "Enter your password",
    name_placeholder: "Enter your full name",
    phone_placeholder: "Enter phone number",
    login_button: "Sign In",
    register_button: "Create Account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    
    // Landing Page
    hero_title: "Professional Vehicle Service Management",
    hero_subtitle: "Streamline your motorcycle service center with our comprehensive management platform",
    hero_cta: "Get Started",
    hero_demo: "View Demo",
    featured_services: "Our Services",
    featured_parts: "Top Products",
    testimonials: "What Our Customers Say",
    contact_us: "Contact Us",
    
    // Services
    services_title: "Our Services",
    services_subtitle: "Professional motorcycle maintenance and repair",
    category_maintenance: "Maintenance",
    category_repair: "Repair",
    category_washing: "Washing",
    category_custom: "Custom Work",
    estimated_time: "Estimated Time",
    contact_quote: "Contact for Quote",
    
    // Parts Store
    parts_title: "Parts & Accessories",
    parts_subtitle: "Quality parts for your motorcycle",
    in_stock: "In Stock",
    out_of_stock: "Out of Stock",
    add_to_inquiry: "Inquire Now",
    category_engine: "Engine Parts",
    category_brake: "Brake Parts",
    category_electrical: "Electrical",
    category_transmission: "Transmission",
    category_accessories: "Accessories",
    
    // Dashboard
    dashboard_title: "Dashboard",
    total_customers: "Total Customers",
    total_jobs: "Total Jobs",
    pending_jobs: "Pending Jobs",
    today_revenue: "Today's Revenue",
    monthly_revenue: "Monthly Revenue",
    low_stock_alert: "Low Stock Alert",
    recent_jobs: "Recent Jobs",
    quick_actions: "Quick Actions",
    new_job: "New Job",
    new_customer: "New Customer",
    
    // Jobs
    jobs_title: "Job Management",
    job_number: "Job #",
    customer_name: "Customer",
    bike_info: "Vehicle Info",
    technician: "Technician",
    create_job: "Create Job",
    quick_entry: "Quick Entry",
    full_entry: "Full Entry",
    job_details: "Job Details",
    services_selected: "Services",
    parts_used: "Parts Used",
    parts_needed: "Parts Needed",
    expected_delivery: "Expected Delivery",
    status_pending: "Pending",
    status_in_progress: "In Progress",
    status_waiting_parts: "Waiting for Parts/Hold",
    status_completed: "Completed",
    status_delivered: "Delivered",
    
    // Customers
    customers_title: "Customer Management",
    customer_details: "Customer Details",
    service_history: "Service History",
    total_spent: "Total Spent",
    total_due: "Total Due",
    bikes_owned: "Vehicles",
    
    // Inventory
    inventory_title: "Inventory Management",
    part_name: "Part Name",
    sku: "SKU",
    category: "Category",
    brand: "Brand",
    stock_qty: "Stock",
    min_stock: "Min Stock",
    purchase_price: "Purchase Price",
    selling_price: "Selling Price",
    add_part: "Add Part",
    adjust_stock: "Adjust Stock",
    low_stock_items: "Low Stock Items",
    suppliers: "Suppliers",
    
    // Invoices
    invoices_title: "Invoices",
    invoice_number: "Invoice #",
    create_invoice: "Create Invoice",
    download_pdf: "Download PDF",
    share_whatsapp: "WhatsApp",
    share: "Share",
    share_via_apps: "Share via Apps",
    thermal_print: "Thermal Print",
    print_invoice: "Print",
    payment_method: "Payment Method",
    paid_amount: "Paid",
    due_amount: "Due",
    payment_cash: "Cash",
    payment_bkash: "bKash",
    payment_nagad: "Nagad",
    payment_bank: "Bank Transfer",
    payment_card: "Card",
    
    // Reports
    reports_title: "Reports & Analytics",
    revenue_report: "Revenue Report",
    jobs_report: "Jobs Report",
    inventory_report: "Inventory Report",
    period_day: "Today",
    period_week: "This Week",
    period_month: "This Month",
    period_year: "This Year",
    export_pdf: "Export PDF",
    export_excel: "Export Excel",
    
    // Settings
    settings_title: "Settings",
    shop_settings: "Shop Settings",
    user_management: "User Management",
    shop_name: "Shop Name",
    shop_logo: "Shop Logo",
    role_owner: "Owner",
    role_manager: "Manager",
    role_technician: "Technician",
    role_front_desk: "Front Desk",
    
    // Marketing
    nav_marketing: "Marketing Tools",
    marketing_title: "Marketing Tools",
    marketing_subtitle: "Grow your business with loyalty rewards, referrals, SMS campaigns & smart reminders",
    marketing_upgrade_required: "Upgrade Required",
    marketing_upgrade_message: "You have no credits. Purchase credits to unlock SMS campaigns and automated reminders.",
    marketing_loyalty_free: "Loyalty Points and Referrals are free to use regardless of credits.",
    marketing_credits_monthly: "Monthly Allocation",
    marketing_loyalty: "Loyalty Points",
    marketing_referrals: "Referrals",
    marketing_campaigns: "SMS Campaigns",
    marketing_reminders: "Reminders",
    marketing_credits: "Credits",
    marketing_credits_balance: "Balance",
    marketing_credits_monthly_balance: "Monthly Balance",
    marketing_credits_topup_balance: "Top-Up Balance",
    marketing_credits_allocation: "Monthly Allocation",
    marketing_credits_used: "Total Used",
    marketing_credits_purchased: "Total Purchased",
    marketing_credits_topup: "Buy Credits",
    marketing_buy_credits: "Buy Credits",
    marketing_credits_topped_up: "Purchased",
    marketing_credits_remaining: "Remaining",
    marketing_transaction_history: "Transaction History",
    marketing_no_transactions: "No transactions yet",
    marketing_purchase_submitted: "Purchase request submitted",
    marketing_purchase_pending: "Awaiting admin approval",
    marketing_topup_submitted: "Purchase request submitted",
    marketing_topup_pending: "Awaiting admin approval",
    marketing_topup_amount: "Number of Credits",
    marketing_credit_packages: "Credit Packages",
    marketing_topup_bundles: "Credit Packages",
    marketing_price_hint: "Estimated",
    marketing_topup_price_hint: "Estimated",
    marketing_package_locked: "Selected package locks the credit amount.",
    marketing_topup_bundle_locked: "Selected package locks the credit amount.",
    marketing_transaction_id: "Transaction ID",
    marketing_payment_phone: "Payment Phone",
    marketing_submit_purchase: "Submit Request",
    marketing_submit_topup: "Submit Request",
    marketing_balance: "Balance",
    marketing_total_purchased: "Total Purchased",
    marketing_total_used: "Total Used",
    marketing_credits_available: "credits available",
    marketing_in_period: "in selected period",
    marketing_filter_all_time: "All Time",
    marketing_filter_today: "Today",
    marketing_filter_this_month: "This Month",
    marketing_filter_this_year: "This Year",
    marketing_filter_specific_month: "Specific Month",
    marketing_filter_specific_year: "Specific Year",
    marketing_filter_date_range: "Date Range",
    marketing_upgrade_title: "Upgrade Your Plan",
    marketing_upgrade_desc: "Your current plan doesn't include marketing credits. Contact the platform admin to upgrade.",
    marketing_subscription: "Subscription",
    sub_current_plan: "Current Plan",
    sub_status: "Status",
    sub_expires: "Expires",
    sub_member_since: "Member Since",
    sub_billing_cycle: "Billing Cycle",
    sub_payment_method: "Payment Method",
    sub_amount: "Amount",
    sub_payment_status: "Payment Status",
    sub_billing_info: "Billing Information",
    sub_available_plans: "Available Plans",
    sub_current: "Current",
    sub_upgrade: "Upgrade",
    sub_monthly: "monthly",
    sub_yearly: "yearly",
    sub_credits_month: "credits/month",
    sub_popular: "Popular",
    sub_features: "Features",
    sub_active: "Active",
    sub_trialing: "Trialing",
    sub_expired: "Expired",
    sub_cancelled: "Cancelled",
    sub_no_plan: "No Plan",
    marketing_points_earned: "Points Earned",
    marketing_points_redeemed: "Points Redeemed",
    marketing_loyalty_points: "Loyalty Points",
    marketing_referred_by: "Referred By",
    marketing_select_referrer: "Select who referred this customer",
    marketing_reminders_due: "Reminders Due",
    marketing_parts_requests: "Parts Requests Pending",
    marketing_request_part: "Request a Part",
    marketing_request_submitted: "Your request has been submitted. The garage will contact you.",
    marketing_reminders_queued: "Reminders Queued",
    completed_today: "Completed Today",

    // Footer
    footer_copyright: "© 2026 MotoBiz. All rights reserved.",
    footer_made_with: "Made with ❤️ in Bangladesh"
  },
  
  bn: {
    // Common
    app_name: "মোটোবিজ",
    tagline: "বাইক সার্ভিস ম্যানেজমেন্ট প্ল্যাটফর্ম",
    loading: "লোড হচ্ছে...",
    save: "সংরক্ষণ",
    cancel: "বাতিল",
    delete: "মুছুন",
    edit: "সম্পাদনা",
    view: "দেখুন",
    search: "অনুসন্ধান",
    filter: "ফিল্টার",
    all: "সব",
    actions: "অ্যাকশন",
    status: "স্ট্যাটাস",
    date: "তারিখ",
    phone: "ফোন",
    email: "ইমেইল",
    address: "ঠিকানা",
    notes: "নোট",
    price: "মূল্য",
    total: "মোট",
    subtotal: "উপমোট",
    discount: "ছাড়",
    currency: "৳",
    
    // Navigation
    nav_home: "হোম",
    nav_services: "সার্ভিস",
    nav_parts: "পার্টস ও স্টোর",
    nav_dashboard: "ড্যাশবোর্ড",
    nav_jobs: "জব",
    nav_customers: "কাস্টমার",
    nav_employees: "কর্মচারী",
    nav_inventory: "ইনভেন্টরি",
    nav_invoices: "চালান",
    nav_reports: "রিপোর্ট",
    nav_services: "সার্ভিস",
    nav_settings: "সেটিংস",
    nav_reviews: "রিভিউ",
    nav_website: "ওয়েবসাইট",
    nav_more: "আরও",
    nav_logout: "লগআউট",
    nav_login: "লগইন",
    
    // Auth
    login_title: "স্বাগতম",
    login_subtitle: "আপনার সার্ভিস সেন্টার পরিচালনা করতে সাইন ইন করুন",
    register_title: "অ্যাকাউন্ট তৈরি করুন",
    register_subtitle: "আপনার বাইক সার্ভিস সেন্টার পরিচালনা শুরু করুন",
    email_placeholder: "আপনার ইমেইল লিখুন",
    password_placeholder: "পাসওয়ার্ড লিখুন",
    name_placeholder: "আপনার পুরো নাম লিখুন",
    phone_placeholder: "ফোন নম্বর লিখুন",
    login_button: "সাইন ইন",
    register_button: "অ্যাকাউন্ট তৈরি করুন",
    no_account: "অ্যাকাউন্ট নেই?",
    have_account: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    
    // Landing Page
    hero_title: "পেশাদার বাইক সার্ভিস ম্যানেজমেন্ট",
    hero_subtitle: "আমাদের সম্পূর্ণ ম্যানেজমেন্ট প্ল্যাটফর্ম দিয়ে আপনার মোটরসাইকেল সার্ভিস সেন্টার পরিচালনা করুন",
    hero_cta: "শুরু করুন",
    hero_demo: "ডেমো দেখুন",
    featured_services: "আমাদের সার্ভিস",
    featured_parts: "জনপ্রিয় পণ্য",
    testimonials: "আমাদের গ্রাহকরা কি বলেন",
    contact_us: "যোগাযোগ করুন",
    
    // Services
    services_title: "আমাদের সার্ভিস",
    services_subtitle: "পেশাদার মোটরসাইকেল রক্ষণাবেক্ষণ ও মেরামত",
    category_maintenance: "রক্ষণাবেক্ষণ",
    category_repair: "মেরামত",
    category_washing: "ওয়াশিং",
    category_custom: "কাস্টম কাজ",
    estimated_time: "আনুমানিক সময়",
    contact_quote: "কোটের জন্য যোগাযোগ করুন",
    
    // Parts Store
    parts_title: "পার্টস ও আনুষঙ্গিক",
    parts_subtitle: "আপনার মোটরসাইকেলের জন্য মানসম্মত পার্টস",
    in_stock: "স্টকে আছে",
    out_of_stock: "স্টকে নেই",
    add_to_inquiry: "এখনই জিজ্ঞাসা করুন",
    category_engine: "ইঞ্জিন পার্টস",
    category_brake: "ব্রেক পার্টস",
    category_electrical: "ইলেকট্রিক্যাল",
    category_transmission: "ট্রান্সমিশন",
    category_accessories: "আনুষঙ্গিক",
    
    // Dashboard
    dashboard_title: "ড্যাশবোর্ড",
    total_customers: "মোট গ্রাহক",
    total_jobs: "মোট জব",
    pending_jobs: "অপেক্ষমান জব",
    today_revenue: "আজকের আয়",
    monthly_revenue: "মাসিক আয়",
    low_stock_alert: "কম স্টক সতর্কতা",
    recent_jobs: "সাম্প্রতিক জব",
    quick_actions: "দ্রুত অ্যাকশন",
    new_job: "নতুন জব",
    new_customer: "নতুন গ্রাহক",
    
    // Jobs
    jobs_title: "জব ম্যানেজমেন্ট",
    job_number: "জব #",
    customer_name: "গ্রাহক",
    bike_info: "বাইকের তথ্য",
    technician: "টেকনিশিয়ান",
    create_job: "জব তৈরি করুন",
    quick_entry: "দ্রুত এন্ট্রি",
    full_entry: "সম্পূর্ণ এন্ট্রি",
    job_details: "জবের বিবরণ",
    services_selected: "সার্ভিস",
    parts_used: "ব্যবহৃত পার্টস",
    parts_needed: "প্রয়োজনীয় পার্টস",
    expected_delivery: "প্রত্যাশিত ডেলিভারি",
    status_pending: "অপেক্ষমান",
    status_in_progress: "চলমান",
    status_waiting_parts: "পার্টসের জন্য অপেক্ষা/হোল্ড",
    status_completed: "সম্পন্ন",
    status_delivered: "ডেলিভারি হয়েছে",
    
    // Customers
    customers_title: "গ্রাহক ম্যানেজমেন্ট",
    customer_details: "গ্রাহকের বিবরণ",
    service_history: "সার্ভিস ইতিহাস",
    total_spent: "মোট খরচ",
    total_due: "মোট বাকি",
    bikes_owned: "বাইক",
    
    // Inventory
    inventory_title: "ইনভেন্টরি ম্যানেজমেন্ট",
    part_name: "পার্টের নাম",
    sku: "SKU",
    category: "ক্যাটাগরি",
    brand: "ব্র্যান্ড",
    stock_qty: "স্টক",
    min_stock: "সর্বনিম্ন স্টক",
    purchase_price: "ক্রয় মূল্য",
    selling_price: "বিক্রয় মূল্য",
    add_part: "পার্ট যোগ করুন",
    adjust_stock: "স্টক সমন্বয়",
    low_stock_items: "কম স্টক আইটেম",
    suppliers: "সরবরাহকারী",
    
    // Invoices
    invoices_title: "চালান",
    invoice_number: "চালান #",
    create_invoice: "চালান তৈরি করুন",
    download_pdf: "PDF ডাউনলোড",
    share_whatsapp: "হোয়াটসঅ্যাপ",
    share: "শেয়ার",
    share_via_apps: "অ্যাপে শেয়ার",
    thermal_print: "থার্মাল প্রিন্ট",
    print_invoice: "প্রিন্ট",
    payment_method: "পেমেন্ট পদ্ধতি",
    paid_amount: "পরিশোধিত",
    due_amount: "বকেয়া",
    payment_cash: "নগদ",
    payment_bkash: "বিকাশ",
    payment_nagad: "নগদ",
    payment_bank: "ব্যাংক ট্রান্সফার",
    payment_card: "কার্ড",
    
    // Reports
    reports_title: "রিপোর্ট ও বিশ্লেষণ",
    revenue_report: "আয় রিপোর্ট",
    jobs_report: "জব রিপোর্ট",
    inventory_report: "ইনভেন্টরি রিপোর্ট",
    period_day: "আজ",
    period_week: "এই সপ্তাহ",
    period_month: "এই মাস",
    period_year: "এই বছর",
    export_pdf: "PDF এক্সপোর্ট",
    export_excel: "Excel এক্সপোর্ট",
    
    // Settings
    settings_title: "সেটিংস",
    shop_settings: "দোকানের সেটিংস",
    user_management: "ইউজার ম্যানেজমেন্ট",
    shop_name: "দোকানের নাম",
    shop_logo: "দোকানের লোগো",
    role_owner: "মালিক",
    role_manager: "ম্যানেজার",
    role_technician: "টেকনিশিয়ান",
    role_front_desk: "ফ্রন্ট ডেস্ক",
    
    // Marketing
    nav_marketing: "মার্কেটিং টুলস",
    marketing_title: "মার্কেটিং টুলস",
    marketing_subtitle: "লয়্যালটি পুরস্কার, রেফারেল, এসএমএস ক্যাম্পেইন ও স্মার্ট রিমাইন্ডার দিয়ে আপনার ব্যবসা বড় করুন",
    marketing_upgrade_required: "আপগ্রেড প্রয়োজন",
    marketing_upgrade_message: "আপনার কোন ক্রেডিট নেই। এসএমএস ক্যাম্পেইন ও স্বয়ংক্রিয় রিমাইন্ডার আনলক করতে ক্রেডিট কিনুন।",
    marketing_loyalty_free: "লয়্যালটি পয়েন্ট ও রেফারেল ক্রেডিট ছাড়াই বিনামূল্যে ব্যবহার করা যায়।",
    marketing_credits_monthly: "মাসিক বরাদ্দ",
    marketing_loyalty: "লয়্যালটি পয়েন্ট",
    marketing_referrals: "রেফারেল",
    marketing_campaigns: "এসএমএস ক্যাম্পেইন",
    marketing_reminders: "রিমাইন্ডার",
    marketing_credits: "ক্রেডিটস",
    marketing_credits_balance: "ব্যালেন্স",
    marketing_credits_monthly_balance: "মাসিক ব্যালেন্স",
    marketing_credits_topup_balance: "টপ-আপ ব্যালেন্স",
    marketing_credits_allocation: "মাসিক বরাদ্দ",
    marketing_credits_used: "মোট ব্যবহৃত",
    marketing_credits_purchased: "মোট ক্রয়কৃত",
    marketing_credits_topup: "ক্রেডিট কিনুন",
    marketing_buy_credits: "ক্রেডিট কিনুন",
    marketing_credits_topped_up: "ক্রয়কৃত",
    marketing_credits_remaining: "অবশিষ্ট",
    marketing_transaction_history: "লেনদেনের ইতিহাস",
    marketing_no_transactions: "এখনো কোন লেনদেন নেই",
    marketing_purchase_submitted: "ক্রয়ের অনুরোধ জমা হয়েছে",
    marketing_purchase_pending: "অ্যাডমিনের অনুমোদনের অপেক্ষায়",
    marketing_topup_submitted: "ক্রয়ের অনুরোধ জমা হয়েছে",
    marketing_topup_pending: "অ্যাডমিনের অনুমোদনের অপেক্ষায়",
    marketing_topup_amount: "ক্রেডিটের সংখ্যা",
    marketing_credit_packages: "ক্রেডিট প্যাকেজ",
    marketing_topup_bundles: "ক্রেডিট প্যাকেজ",
    marketing_price_hint: "আনুমানিক",
    marketing_topup_price_hint: "আনুমানিক",
    marketing_package_locked: "প্যাকেজ নির্বাচন করা হয়েছে, তাই ক্রেডিট সংখ্যা পরিবর্তন করা যাবে না।",
    marketing_topup_bundle_locked: "প্যাকেজ নির্বাচন করা হয়েছে, তাই ক্রেডিট সংখ্যা পরিবর্তন করা যাবে না।",
    marketing_transaction_id: "লেনদেন আইডি",
    marketing_payment_phone: "পেমেন্ট ফোন",
    marketing_submit_purchase: "অনুরোধ জমা দিন",
    marketing_submit_topup: "অনুরোধ জমা দিন",
    marketing_balance: "ব্যালেন্স",
    marketing_total_purchased: "মোট ক্রয়কৃত",
    marketing_total_used: "মোট ব্যবহৃত",
    marketing_credits_available: "ক্রেডিট উপলব্ধ",
    marketing_in_period: "নির্বাচিত সময়ে",
    marketing_filter_all_time: "সব সময়",
    marketing_filter_today: "আজ",
    marketing_filter_this_month: "এই মাস",
    marketing_filter_this_year: "এই বছর",
    marketing_filter_specific_month: "নির্দিষ্ট মাস",
    marketing_filter_specific_year: "নির্দিষ্ট বছর",
    marketing_filter_date_range: "তারিখ পরিসর",
    marketing_upgrade_title: "আপনার প্ল্যান আপগ্রেড করুন",
    marketing_upgrade_desc: "আপনার বর্তমান প্ল্যানে মার্কেটিং ক্রেডিট নেই। আপগ্রেড করতে প্ল্যাটফর্ম অ্যাডমিনের সাথে যোগাযোগ করুন।",
    marketing_subscription: "সাবস্ক্রিপশন",
    sub_current_plan: "বর্তমান প্ল্যান",
    sub_status: "স্ট্যাটাস",
    sub_expires: "মেয়াদ শেষ",
    sub_member_since: "সদস্য হয়েছেন",
    sub_billing_cycle: "বিলিং সাইকেল",
    sub_payment_method: "পেমেন্ট পদ্ধতি",
    sub_amount: "পরিমাণ",
    sub_payment_status: "পেমেন্ট স্ট্যাটাস",
    sub_billing_info: "বিলিং তথ্য",
    sub_available_plans: "উপলব্ধ প্ল্যানসমূহ",
    sub_current: "বর্তমান",
    sub_upgrade: "আপগ্রেড",
    sub_monthly: "মাসিক",
    sub_yearly: "বার্ষিক",
    sub_credits_month: "ক্রেডিট/মাস",
    sub_popular: "জনপ্রিয়",
    sub_features: "সুবিধাসমূহ",
    sub_active: "সক্রিয়",
    sub_trialing: "ট্রায়াল",
    sub_expired: "মেয়াদ শেষ",
    sub_cancelled: "বাতিল",
    sub_no_plan: "কোন প্ল্যান নেই",
    marketing_points_earned: "পয়েন্ট অর্জিত",
    marketing_points_redeemed: "পয়েন্ট রিডিম",
    marketing_loyalty_points: "লয়্যালটি পয়েন্ট",
    marketing_referred_by: "রেফার করেছেন",
    marketing_select_referrer: "কোন গ্রাহক রেফার করেছেন তা নির্বাচন করুন",
    marketing_reminders_due: "রিমাইন্ডার ডিউ",
    marketing_parts_requests: "পার্টস অনুরোধ পেন্ডিং",
    marketing_request_part: "পার্ট অনুরোধ করুন",
    marketing_request_submitted: "আপনার অনুরোধ জমা হয়েছে। গ্যারেজ আপনার সাথে যোগাযোগ করবে।",
    marketing_reminders_queued: "রিমাইন্ডার কিউ হয়েছে",
    completed_today: "আজ সম্পন্ন",

    // Footer
    footer_copyright: "© ২০২৬ মোটোবিজ। সর্বস্বত্ব সংরক্ষিত।",
    footer_made_with: "বাংলাদেশে ❤️ দিয়ে তৈরি"
  }
};

export const formatCurrency = (amount, lang = 'en') => {
  // Handle undefined/null/NaN amounts
  if (amount === undefined || amount === null || isNaN(amount)) {
    return '৳0';
  }
  const formatted = amount.toLocaleString(lang === 'bn' ? 'bn-BD' : 'en-BD');
  return `৳${formatted}`;
};

export const formatDate = (dateString, lang = 'en') => {
  const date = new Date(dateString);
  if (lang === 'bn') {
    return date.toLocaleDateString('bn-BD', { day: 'numeric', month: 'long', year: 'numeric' });
  }
  return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const toBengaliNumber = (num) => {
  const bengaliDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
  return num.toString().replace(/\d/g, (d) => bengaliDigits[d]);
};
